import { useRef } from 'react';
import { lt } from '@mews/framework';
import { Button } from '@optimus-web/core';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { FloatingPanel } from '@mews/b2b-ui';
import { useRoutingRuleConflictsContext } from '../../../../../contexts/RoutingRuleConflictsContext';
import { ConflictsDialogContent } from './ConflictsDialogContent';

export const ConflictsDialog = () => {
    const { isActive, handleClose } = useRoutingRuleConflictsContext();

    const footer = {
        primary: (
            <Button
                variant="tertiary"
                type="button"
                size="medium"
                onClick={handleClose}
                data-test-id={DataTestId.RoutingRulesConflictsDialogCancel}
            >
                {lt(TextKey.Cancel)}
            </Button>
        ),
    };

    const contentRef = useRef<HTMLDivElement>(null);

    return (
        <FloatingPanel
            active={isActive}
            onClose={handleClose}
            title={lt(TextKey.RoutingRulesFormConflictsTitle)}
            footer={footer}
            contentRef={contentRef}
        >
            <ConflictsDialogContent />
        </FloatingPanel>
    );
};
